<script lang="ts" setup>
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VRouterTabs from '@components/tabs/VRouterTabs/VRouterTabs.vue';
import VChangeHistory from '@modules/change-history/components/VChangeHistory/VChangeHistory.vue';
import {
  PLAYER_PROFILE_PERMISSIONS,
  TRANSLATION_PLAYER_DETAILS,
} from '@modules/players/submodules/PlayerProfile/constants';
import { usePlayerProfilePage } from '@modules/players/submodules/PlayerProfile/pages/PlayerProfilePage/composable';

import type { IPlayersProfileProps } from '../../types';
import PlayerTrackingHistoryEditPage from '../PlayerTrackingHistoryEditPage/PlayerTrackingHistoryEditPage.vue';

const props = defineProps<IPlayersProfileProps>();

const {
  tabItems,
  componentProps,
  isTrackingPage,
  playerHistoryList,
  onSubmit,
  onRemove,
  isPlayerProfileLoading,
  toEditPage,
  clearError,
} = usePlayerProfilePage(
  props.mainDataRoute,
  props.activityRoute,
  props.trackerRoute,
  props.editHistoryRoute,
);
</script>

<template>
  <VCard v-data-qa-auto-id="'PlayerProfilePage'"
    :title="$getTranslation(TRANSLATION_PLAYER_DETAILS, 'PLAYER_DETAILS_HEADER')"
    class="rounded-b-none"
    type="form"
  >
    <VLoader
      :loading="isPlayerProfileLoading"
      mode="overlay"
    >
      <VRouterTabs
        :items="tabItems"
        class="mb-10"
      />
      <RouterView v-slot="{ Component }">
        <component
          :is="Component"
          v-bind="componentProps"
          @submit="onSubmit($event)"
          @interacted="clearError($event)"
        />
      </RouterView>
    </VLoader>
  </VCard>
  <div
    v-if="isTrackingPage"
    class="rounded-b-xl border-t"
  >
    <VChangeHistory
      class="rounded-t-none"
      :list="playerHistoryList"
      :edit-permission="PLAYER_PROFILE_PERMISSIONS.PLAYERS_TRACKING"
      :delete-permission="PLAYER_PROFILE_PERMISSIONS.PLAYERS_TRACKING"
      @delete="onRemove($event)"
      @edit="toEditPage($event)"
    >
      <PlayerTrackingHistoryEditPage :back-route="trackerRoute.name" />
    </VChangeHistory>
  </div>
</template>
